import { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  resetCP,
  setSubpage,
  setLocationId,
  setMultiLocationIds,
  setTimeFrequency,
  setForecastDate,
  setVariable,
  setRounds,
  selectDVCPMATrackingForecastTriggerRequest,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import { AgroTrackingForecastPreference } from 'types/Meteorology/Agro/TrackingForecast/DetailedView/preference';
import { Subpage, SUBPAGE_SUBMENU_OPTIONS } from 'types/Meteorology/Agro/TrackingForecast/DetailedView';
import simpleDiffToFormattedDate from 'helper/simpleDiffToFormattedDate';

export default function useSelectPreference() {
  const [shouldTriggerRequest, setShouldTriggerRequest] = useState(false);
  const triggerRequest = useSelector(selectDVCPMATrackingForecastTriggerRequest);

  const selectPreference = useCallback((preference: AgroTrackingForecastPreference) => () => {
    const { params, submenu } = preference;

    store.dispatch(resetCP());

    const subpage = Object.keys(SUBPAGE_SUBMENU_OPTIONS).find(
      (key) => SUBPAGE_SUBMENU_OPTIONS[key as Subpage] === submenu,
    );
    if (subpage) {
      store.dispatch(setSubpage(subpage as Subpage));
    }
    if (params.timeFrequency) {
      store.dispatch(setTimeFrequency(params.timeFrequency));
    }
    if (params.variable) {
      store.dispatch(setVariable(params.variable));
    }
    if (params.locationId) {
      store.dispatch(setLocationId(params.locationId));
    }
    if (params.locationIds) {
      store.dispatch(setMultiLocationIds(params.locationIds));
    }
    if (params.forecastDate) {
      const formattedDate = simpleDiffToFormattedDate(params.forecastDate, 'yyyy-MM-dd');
      store.dispatch(setForecastDate(formattedDate));
    }
    if (params.forecastDates) {
      const formattedDates = params.forecastDates.map(
        (dateDiffs) => simpleDiffToFormattedDate(dateDiffs, 'yyyy-MM-dd'),
      );
      store.dispatch(setRounds(formattedDates));
    }

    setShouldTriggerRequest(true);
  }, []);

  useEffect(() => {
    if (triggerRequest && shouldTriggerRequest) {
      triggerRequest();
      setShouldTriggerRequest(false);
    }
  }, [triggerRequest, shouldTriggerRequest]);

  return {
    selectPreference,
  };
}
